import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Box, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    borderRadius: 10,
    padding: theme.spacing(0.5),
    backgroundColor: theme.mode === "light" ? "#f5f7fa" : "rgba(255, 255, 255, 0.06)",
    border: `1px solid ${theme.mode === "light" ? "#e6e9ef" : "rgba(255, 255, 255, 0.14)"}`,
  },
  tabsRoot: {
    minHeight: 42,
  },
  indicator: {
    display: "none",
  },
  tabRoot: {
    minHeight: 34,
    textTransform: "none",
    borderRadius: 8,
    fontWeight: 500,
    fontSize: "0.86rem",
    color: theme.mode === "light" ? "#5f6776" : "#c8d0df",
    transition: "all 140ms ease",
  },
  tabSelected: {
    color: `${theme.mode === "light" ? "#13294b" : "#f2f6ff"} !important`,
    backgroundColor: theme.mode === "light" ? "#ffffff" : "rgba(255, 255, 255, 0.12)",
    boxShadow:
      theme.mode === "light"
        ? "0 1px 2px rgba(16, 24, 40, 0.08)"
        : "0 1px 2px rgba(0, 0, 0, 0.35)",
  },
}));

const SectionTabsNav = ({ tabs = [] }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const currentIndex = Math.max(
    0,
    tabs.findIndex((tab) => tab.to === location.pathname)
  );

  const handleChange = (event, newValue) => {
    const selected = tabs[newValue];
    if (selected && selected.to !== location.pathname) {
      history.push(selected.to);
    }
  };

  if (!tabs.length) {
    return null;
  }

  return (
    <Box mb={1}>
      <Box className={classes.wrapper}>
        <Tabs
          value={currentIndex}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          aria-label="section navigation tabs"
          className={classes.tabsRoot}
          classes={{ indicator: classes.indicator }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.to}
              label={tab.label}
              disableRipple
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
};

export default SectionTabsNav;
